import { FC } from "react";
import { ExtraStateContext } from "..";
import { useProcess } from "../../../../process-context";
import LongTermContent from "./long-term/content";
import ShortTermContent from "./short-term/content";

const FormContent: FC = () => {
  const { isLongTerm } = useProcess<ExtraStateContext>();

  return isLongTerm ? <LongTermContent /> : <ShortTermContent />;
};

export default FormContent;
